import React from 'react'

// query
import { useQuery } from '@apollo/client'
import { GET_EQUIPMENT_BY_ID_WITH_NAME } from '../../../../../graphql/equipment/equipment.queries'

// components
import Heading from '../../../../../components/text/Heading/Heading.component'

export default function EquipmentName({ id }) {
    let equipment = {}

    const { loading, error, data } = useQuery(GET_EQUIPMENT_BY_ID_WITH_NAME, {
        variables: { id }
    })

    if(data && data.equipment) {
        equipment = {...data.equipment}
    }

    return (<Heading text={equipment.name} />)
}